import { render, staticRenderFns } from "./screenCapture.vue?vue&type=template&id=2bcb8120&scoped=true"
import script from "./screenCapture.vue?vue&type=script&lang=js"
export * from "./screenCapture.vue?vue&type=script&lang=js"
import style0 from "./screenCapture.vue?vue&type=style&index=0&id=2bcb8120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb8120",
  null
  
)

export default component.exports